import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { values } from 'ramda';

/*
 *
 * International — e.g. +1 213 373 4253
 * International_plaintext — (aka E.164) e.g. +12133734253
 * National — e.g. (213) 373-4253
 *
 */
export const PARSE_TYPE = {
  INTERNATIONAL: 'INTERNATIONAL',
  INTERNATIONAL_PLAINTEXT: 'INTERNATIONAL_PLAINTEXT',
  NATIONAL: 'NATIONAL',
};

export const formatIntPhoneNumber = (phone = '') => {
  const phoneNumber = parsePhoneNumberFromString(phone);
  if (phoneNumber) return phoneNumber.format(PARSE_TYPE.INTERNATIONAL);
};

export const parsePhoneNumber = (phone = '', country, type) => {
  if (!country) return;
  const phoneNumber = parsePhoneNumberFromString(phone, country.toUpperCase());
  if (phoneNumber) return phoneNumber.format(type);
};

export const extractAddress = address =>
  values(address)
    .filter(Boolean)
    .join(' ');

export const extractAddressFormatted = address =>
  values(address)
    .filter(Boolean)
    .join(', ');
